import { UPLOAD_DOCTOR_IMAGE, UPDATE_DOCTOR_INFO } from "../constants/edit-info";

export function UploadImage(doctorId: number, fileName: string, file: Blob, description: string) {
  const formData = new FormData();
  formData.append("fileName", fileName);
  formData.append("file", file);
  formData.append("description", description);
  return {
    type: UPLOAD_DOCTOR_IMAGE,
    api: true,
    payload: {
      method: "POST",
      url: `personal-info/${doctorId}/upload`,
      data: formData,
    },
  };
}

export function UpdateDoctorInfo(
  doctorId: number,
  professions: number[],
  profilePicDelete?: boolean,
  profilePicId?: string,
  galleryPics?: string[]
) {
  return {
    type: UPDATE_DOCTOR_INFO,
    api: true,
    payload: {
      method: "POST",
      url: `personal-info/${doctorId}/update`,
      data: { professions, profilePicDelete, profilePicId, galleryPics },
    },
  };
}
